import {
  Collapse,
  Grid,
  TextField,
  Button,
  Box,
  Chip,
  Typography,
  Autocomplete,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function Filter({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  bayList,
}) {
  // Extract unique bay values for dropdown
  const bayOptions = bayList.map((item) => item.bay);

  return (
    <Collapse in={filterOpen} timeout="auto" unmountOnExit>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              options={bayOptions}
              value={filterData.bay || ""}
              onChange={(event, newValue) => {
                handleChangeFilter("bay")(event, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Bay"
                  fullWidth
                  size="small"
                  placeholder="Select or enter bay"
                />
              )}
              freeSolo
              disableClearable={false}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Time"
              value={filterData.time || ""}
              onChange={handleChangeFilter("time")}
              fullWidth
              size="small"
              placeholder="Enter time (e.g., 11:00 AM)"
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={handleClearFilters}
                sx={{
                  minWidth: "80px",
                }}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                onClick={handleFilter}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: "#7152F3",
                  "&:hover": { backgroundColor: "#5c34fa" },
                  minWidth: "100px",
                }}
              >
                Filter
              </Button>
            </Box>
          </Grid>
        </Grid>

        {Object.keys(submittedData).length > 0 && (
          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ color: "#48505E" }}>
              Applied Filters:
            </Typography>
            {Object.entries(submittedData).map(([key, value]) => (
              <Chip
                key={key}
                label={`${key}: ${value}`}
                onDelete={() => handleRemove(key)}
                size="small"
                sx={{
                  backgroundColor: "#F0F0F0",
                  "& .MuiChip-deleteIcon": {
                    color: "#7152F3",
                  },
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </Collapse>
  );
}